<script>
export default {
    props: [
        'modalData',
        'openModal',
        'modalOpen',
        'closeModal'
    ],
    data() {
        return {
        };
    },
}

</script>


// WEBPACK FOOTER //
// resources/components/apps/floorplan-detail.vue